import { Pagination, SelectChangeEvent } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import ContractsModal from '../../components/ContractsModal'
import Dialog from '../../components/Dialog'
import api, { operation } from '../../services/axios'
import { StoreState } from '../../store'
import {
    Container,
    Contracts,
    Header,
    HistoricoTable,
    ExtractFilter,
    Option,
    FilterContainer,
} from './styles'
import { FiDownload } from 'react-icons/fi'
import { MdKeyboardArrowUp, MdMoreVert, MdOutlineSearch } from 'react-icons/md'
import {
    ContratoProtocol,
    Filters,
    GarantiasContratoCsv,
    OrderBy,
} from './interfaces'
import Loading from '../../components/Loading'
import { cnpjCpfMask } from '../../utils/masks'
import { CSVLink } from 'react-csv'
import { get } from 'lodash'
import { utils, writeFileXLSX } from 'xlsx'
import { arranjosPrincipais } from '../../utils/arranjos'
import RowsTableExtratos from '../../components/RowsTableExtratos'
import { useBancos } from '../../hooks/bancos'
import { Popover, RadioGroup } from '@headlessui/react'
import classNames from 'classnames'
import { BsFilter, BsPlus, BsX } from 'react-icons/bs'
import { Link } from 'react-router-dom'
import { selectedMenu } from '../../store/modules/menu/actions'
import { useDispatch } from 'react-redux'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

import ModalBackground from '../../components/ModalBackground'
import { useCredenciadoras } from '../../hooks/credenciadoras'
import dayjs from '../../libs/dayjs'

const headers = [
    { label: 'Referência externa', key: 'RefExtContrato' },
    { label: 'Protocolo', key: 'protocolo' },
    { label: 'Tipo de Contrato', key: 'tipoContrato' },
    { label: 'Data de Assinatura', key: 'dataAssinatura' },
    { label: 'Credenciadora', key: 'crendeciadora' },
    { label: 'Cnpj do participante', key: 'cnpjParticipante' },
    { label: 'Tipo de serviço', key: 'tipoServico' },
    { label: 'Tipo do efeito', key: 'tipoEfeito' },
    { label: 'Modalidade de operação', key: 'modalidadeOp' },
    { label: 'Canal', key: 'canal' },
    { label: 'Cnpj do pagador', key: 'cnpjPagador' },
    { label: 'Pagador', key: 'pagador' },
    { label: 'Cnpj do recebedor', key: 'cnpjRecebedor' },
    { label: 'Recebedor', key: 'recebedor' },
    { label: 'Banco', key: 'banco' },
    { label: 'Compe', key: 'compe' },
    { label: 'Ispb', key: 'ispb' },
    { label: 'Agência', key: 'agencia' },
    { label: 'Conta', key: 'conta' },
    { label: 'Tipo de conta', key: 'tipoConta' },
    { label: 'Data de vencimento da UR', key: 'DataVencimentoUR' },
    { label: 'Bandeira', key: 'bandeira' },
    { label: 'Valor da UR', key: 'valorUR' },
    { label: 'Valor contrato do total', key: 'valorTotalContrato' },
    { label: 'Situação', key: 'situacao' },
    { label: 'Observação', key: 'obs' },
]
const defaultFiltros: Filters = {
    credenciadora: 'all',
    situacao: 'all',
    porCnpj_cpf: '',
    dataInicio: '',
    dataFim: '',
    categoria: 'all',
    tipo: 'all',
}
const Extratos: React.FC = () => {
    const { cnpj_cpf, empresa } = useSelector(
        (state: StoreState) => state.auth.user
    )
    const { todasCredenciadoras } = useCredenciadoras()

    const dispatch = useDispatch()
    const { bancos } = useBancos()
    const [contrats, setContracts] = useState<ContratoProtocol[]>([])
    const [contractSelected, setContractSelected] = useState(
        {} as ContratoProtocol
    )
    const [contractsDownload, setContractsDownload] = useState<
        GarantiasContratoCsv[]
    >([])
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [contractsPage, setContractsPage] = useState(1)
    const [contractsCount, setContractsCount] = useState(0)
    const [filtros, setFiltros] = useState(defaultFiltros as Filters)
    const [ordenarPorDataCriacao, setOrdenarPorDataCriacao] =
        useState<OrderBy>('desc')
    const [ordenarPorValor, setOrdenarPorValor] = useState<OrderBy>(null)
    // const [showfilters, setShowfilters] = useState(false)
    const [dateRange, setDateRange] = useState<Array<null | Date>>([null, null])
    const [startDate, endDate] = dateRange

    const getContractsDownLoad = useCallback(() => {
        operation.attempt(async (currentAttempt) => {
            try {
                // setIsLoading(true)
                const response = await api.get(`/extratos/${cnpj_cpf}`)
                setContractsDownload(response.data)
                // setIsLoading(false)
            } catch (e: any) {
                // setIsLoading(false)
                const status = get(e, 'response.status', '')
                // toast.error(erro)
                if (status === 401) {
                    if (operation.retry(e)) return
                }
            }
        })
    }, [cnpj_cpf])

    const getContracts = useCallback(async () => {
        operation.attempt(async (currentAttempt) => {
            try {
                setIsLoading(true)
                const { data } = await api.post(`/extrato/${contractsPage}`, {
                    cnpj_cpf,
                    filtros: {
                        ...filtros,
                        byCpnj_cpf: filtros.porCnpj_cpf.replace(/\D/g, ''),
                        dataInicio: startDate
                            ? dayjs(startDate).format('YYYY-MM-DD')
                            : '',
                        dataFim: endDate
                            ? dayjs(endDate).format('YYYY-MM-DD')
                            : '',
                    },
                    ordenarPorDataCriacao,
                    ordenarPorValor,
                })
                setContracts(data.contracts)
                setContractsCount(data.quantPaginas)
                setIsLoading(false)
            } catch (e: any) {
                setIsLoading(false)
                const status = get(e, 'response.status', '')
                // toast.error(erro)
                if (status === 401) {
                    if (operation.retry(e)) return
                }
            }
        })
    }, [
        cnpj_cpf,
        contractsPage,
        filtros,
        ordenarPorValor,
        ordenarPorDataCriacao,
        endDate,
        startDate,
    ])

    useEffect(() => {
        getContracts()
    }, [getContracts])

    useEffect(() => {
        getContractsDownLoad()
    }, [getContractsDownLoad])

    const dataCsv = contractsDownload?.map((garantia) => {
        const banco = bancos[garantia.DP_compe]
        const credenciadora =
            todasCredenciadoras[garantia?.contrato?.credenciadora]
        const bandeira =
            arranjosPrincipais[
                garantia.DefUR_listaCodigoArranjoPagamento as keyof typeof arranjosPrincipais
            ]
        return {
            RefExtContrato: garantia.contrato.referenciaExterna,
            protocolo: garantia.contrato?.contratoRetorno?.protocolo,
            tipoContrato: garantia.contrato.tipoContrato,
            dataAssinatura: garantia.contrato?.dataAssinatura,
            crendeciadora: credenciadora,
            cnpjParticipante: garantia.contrato?.cnpjParticipante,
            tipoServico: garantia.contrato?.statusContrato,
            tipoEfeito: garantia.contrato?.tipoEfeito,
            modalidadeOp: garantia.contrato?.modalidadeOperacao,
            canal: garantia.contrato?.canal,
            cnpjPagador: garantia.contrato?.cnpjPagador,
            pagador: garantia.contrato?.nomePagador,
            cnpjRecebedor: garantia.contrato?.cnpjRecebedor,
            recebedor: garantia.contrato?.nomeRecebedor,
            banco: banco,
            compe: garantia.DP_compe,
            ispb: garantia.DP_ispb,
            agencia: garantia.DP_agencia,
            conta: garantia.DP_numeroConta,
            tipoConta: garantia.DP_tipoConta,
            DataVencimentoUR: garantia.DefUR_dataFim,
            bandeira: bandeira,
            valorUR: Number(garantia.valorAOnerar).toFixed(2),
            valorTotalContrato: Number(garantia.contrato?.saldoDevedor).toFixed(
                2
            ),
            situacao: !garantia.contrato?.visibilidade
                ? 'Pendente de confirmação da registradora'
                : garantia.contrato?.situacao,
            obs: garantia.contrato?.observacao,
        }
    })

    // const valorTotalContracts = contrats?.reduce((valor, atual) => {
    //     return valor + Number(atual.saldoDevedor)
    // }, 0)

    function handleSelectContract(contract: ContratoProtocol) {
        setContractSelected(contract)
        setIsModalOpen(true)
    }

    const exportFile = useCallback(() => {
        const dataXlsx = contractsDownload?.map((garantia) => {
            const banco = bancos[garantia.DP_compe]
            const credenciadora =
                todasCredenciadoras[garantia?.contrato?.credenciadora]
            const bandeira =
                arranjosPrincipais[
                    garantia.DefUR_listaCodigoArranjoPagamento as keyof typeof arranjosPrincipais
                ]
            return {
                'Referência externa': garantia.contrato.referenciaExterna,
                Protocolo: garantia.contrato.contratoRetorno?.protocolo,
                'Tipo do contrato': garantia.contrato?.tipoContrato,
                'Data de assinatura': garantia.contrato?.dataAssinatura,
                Crendeciadora: credenciadora,
                'Cnpj do participante': garantia.contrato?.cnpjParticipante,
                'Tipo de servico': garantia.contrato?.statusContrato,
                'Tipo do efeito': garantia.contrato?.tipoEfeito,
                'Modalidade de operação': garantia.contrato?.modalidadeOperacao,
                Canal: garantia.contrato?.canal,
                'Cnpj do pagador': garantia.contrato?.cnpjPagador,
                Pagador: garantia.contrato?.nomePagador,
                'Cnpj do recebedor': garantia.contrato?.cnpjRecebedor,
                Recebedor: garantia.contrato?.nomeRecebedor,
                Banco: banco,
                Compe: garantia.DP_compe,
                Ispb: garantia.DP_ispb,
                Agência: garantia.DP_agencia,
                Conta: garantia.DP_numeroConta,
                'Tipo de conta': garantia.DP_tipoConta,
                'Data de vencimento da UR': garantia.DefUR_dataFim,
                Bandeira: bandeira,
                'Valor da UR': Number(garantia.valorAOnerar).toFixed(2),
                'Valor total do contrato': Number(
                    garantia.contrato?.saldoDevedor
                ).toFixed(2),
                'Situação do contrato': !garantia.contrato?.visibilidade
                    ? 'Pendente de confirmação da registradora'
                    : garantia.contrato?.situacao,
                Observação: garantia.contrato?.observacao,
            }
        })
        const ws = utils.json_to_sheet(dataXlsx)
        const wb = utils.book_new()
        utils.book_append_sheet(wb, ws, 'Data')
        writeFileXLSX(wb, 'Extratos.xlsx')
    }, [contractsDownload, bancos, todasCredenciadoras])

    function handleOrderBy(order: string) {
        if (order === 'assinatura') {
            const order = ordenarPorDataCriacao === 'desc' ? 'asc' : 'desc'
            setOrdenarPorDataCriacao(order)
            setOrdenarPorValor(null)
        } else if (order === 'valor') {
            const order = ordenarPorValor === 'desc' ? 'asc' : 'desc'
            setOrdenarPorValor(order)
            setOrdenarPorDataCriacao(null)
        }

        return
    }

    function handleChange(
        e:
            | React.ChangeEvent<
                  HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
              >
            | SelectChangeEvent<string>
    ) {
        if (e.target.name === 'porCnpj_cpf') {
            const value = cnpjCpfMask(e.target.value)
            e.target.value = value
        }
        setFiltros({
            ...filtros,
            [e.target.name]: e.target.value,
        })
    }
    function renderContractRows() {
        return contrats?.map((contract: ContratoProtocol) => {
            return (
                <RowsTableExtratos
                    key={contract.id}
                    contract={contract}
                    handleSelectContract={handleSelectContract}
                />
            )
        })
    }
    return (
        <Container>
            <ExtractFilter>
                <div className="top-bar">
                    <h1>Extrato da conta {empresa}</h1>
                    <div className="right-side">
                        <div className="flex relative ">
                            <span className="rounded-l-md inline-flex  items-center px-3 border-t bg-white border-l border-b  border-gray-300 text-gray-500 shadow-sm text-sm">
                                <MdOutlineSearch size={22} />
                            </span>
                            <input
                                type="text"
                                id="porCnpj_cpf"
                                name="porCnpj_cpf"
                                className=" rounded-r-lg flex-1 appearance-none border border-gray-300 w-full py-1 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                                value={filtros.porCnpj_cpf}
                                onChange={handleChange}
                                placeholder="Procure por um CPF ou CNPJ"
                            />
                        </div>
                        <Link
                            to="/pagamento/criar"
                            className="payment-button"
                            onClick={() =>
                                dispatch(
                                    selectedMenu({
                                        mainMenu: 'Pagamento',
                                        subMenu: '',
                                        currentLink: '/pagamento',
                                    })
                                )
                            }
                        >
                            <button className="py-1 px-2 flex items-center gap-x-1 bg-green-600 hover:opacity-90 focus:ring-green-500 focus:ring-offset-green-200 text-white transition ease-in duration-100 text-center text-base font-normal shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-md ">
                                <BsPlus size={24} />
                                Criar pagamento
                            </button>
                        </Link>
                    </div>
                </div>
                <div className="bottom-bar">
                    <RadioGroup
                        value={filtros.categoria}
                        onChange={(value: string) =>
                            setFiltros({
                                ...filtros,
                                categoria: value,
                            })
                        }
                    >
                        <RadioGroup.Label className="text-2xl text-gray-900 sr-only">
                            Qual categoria de contrato você deseja filtrar?
                        </RadioGroup.Label>
                        <div className="select">
                            <RadioGroup.Option value="all">
                                {({ checked }) => (
                                    <Option
                                        className={classNames(
                                            'cursor-pointer py-1 px-3 text-base rounded-3xl shadow-sm opacity-80 ',
                                            {
                                                'text-white bg-blue-600 border-blue-500 border-2  opacity-80':
                                                    checked,
                                            },
                                            {
                                                'text-gray-500 bg-white border border-gray-400 transition ease-in-out hover:opacity-100':
                                                    !checked,
                                            }
                                        )}
                                    >
                                        Todos
                                    </Option>
                                )}
                            </RadioGroup.Option>
                            <RadioGroup.Option value="pago">
                                {({ checked }) => (
                                    <Option
                                        className={classNames(
                                            'cursor-pointer py-1 px-3 text-base rounded-3xl shadow-sm opacity-80 ',
                                            {
                                                'text-white bg-blue-600 border-blue-500 border-2  opacity-80':
                                                    checked,
                                            },
                                            {
                                                'text-gray-500 bg-white border border-gray-400 transition ease-in-out hover:opacity-100':
                                                    !checked,
                                            }
                                        )}
                                    >
                                        Pagos
                                    </Option>
                                )}
                            </RadioGroup.Option>
                            <RadioGroup.Option value="recebido">
                                {({ checked }) => (
                                    <Option
                                        className={classNames(
                                            'cursor-pointer py-1 px-3 text-base rounded-3xl shadow-sm opacity-80 ',
                                            {
                                                'text-white bg-blue-600 border-blue-500 border-2  opacity-80':
                                                    checked,
                                            },
                                            {
                                                'text-gray-500 bg-white border border-gray-400 transition ease-in-out hover:opacity-100':
                                                    !checked,
                                            }
                                        )}
                                    >
                                        Recebidos
                                    </Option>
                                )}
                            </RadioGroup.Option>
                        </div>
                    </RadioGroup>
                    <div className="right-side">
                        <DatePicker
                            selectsRange={true}
                            startDate={startDate}
                            endDate={endDate}
                            placeholderText="Selecione um período de data"
                            className="flex-1 appearance-none border rounded-lg border-gray-300  py-1 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                            onChange={(update) => {
                                setDateRange(update)
                            }}
                            dateFormat="dd/MM/yyyy"
                        />
                        <Popover className="popover">
                            <Popover.Button>
                                <button className="appearance-none border rounded-lg border-gray-300 py-1 px-2 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base">
                                    <BsFilter size={23} />
                                </button>
                            </Popover.Button>
                            <Popover.Panel>
                                {({ close }) => (
                                    <>
                                        <ModalBackground close={close} />
                                        <FilterContainer>
                                            <header>
                                                <p>Adicionar filtros extras</p>
                                                <button onClick={() => close()}>
                                                    <BsX
                                                        size={34}
                                                        color="#333"
                                                    />
                                                </button>
                                            </header>
                                            <form>
                                                <div className="input-group">
                                                    <div className="input-wrapper">
                                                        <label
                                                            htmlFor="credenciadora"
                                                            className="text-base text-gray-700 mb-2 block"
                                                        >
                                                            Credenciadora:{' '}
                                                        </label>
                                                        <select
                                                            id="credenciadora"
                                                            value={
                                                                filtros.credenciadora
                                                            }
                                                            name="credenciadora"
                                                            onChange={
                                                                handleChange
                                                            }
                                                            className="rounded-lg w-full flex-1 border border-gray-300 py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent mt-1"
                                                        >
                                                            <option
                                                                value="all"
                                                                className=""
                                                            >
                                                                Todas
                                                            </option>
                                                            {Object.entries(
                                                                todasCredenciadoras
                                                            ).map(
                                                                ([
                                                                    chave,
                                                                    valor,
                                                                ]) => {
                                                                    return (
                                                                        <option
                                                                            key={
                                                                                chave
                                                                            }
                                                                            value={
                                                                                chave
                                                                            }
                                                                        >
                                                                            {
                                                                                valor
                                                                            }
                                                                        </option>
                                                                    )
                                                                }
                                                            )}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="input-group">
                                                    <div className="input-wrapper">
                                                        <label
                                                            htmlFor="tipo"
                                                            className="text-base text-gray-700 mb-2 block"
                                                        >
                                                            Tipo Contrato:{' '}
                                                        </label>
                                                        <select
                                                            name="tipo"
                                                            id="tipo"
                                                            onChange={
                                                                handleChange
                                                            }
                                                            value={filtros.tipo}
                                                            className="rounded-lg w-full flex-1 border border-gray-300 py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent mt-1"
                                                        >
                                                            <option
                                                                value="all"
                                                                className=""
                                                            >
                                                                Todos
                                                            </option>
                                                            <option value="pagamento">
                                                                Pagamento
                                                            </option>
                                                            <option value="cobranca">
                                                                Cobrança
                                                            </option>
                                                            <option value="recorrencia">
                                                                Recorrência
                                                            </option>
                                                            <option value="antecipacao">
                                                                Antecipação
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <div className="input-wrapper">
                                                        <label
                                                            htmlFor="situacao"
                                                            className="text-base text-gray-700 mb-2 block"
                                                        >
                                                            Status Contrato:{' '}
                                                        </label>
                                                        <select
                                                            name="situacao"
                                                            id="situacao"
                                                            onChange={
                                                                handleChange
                                                            }
                                                            value={
                                                                filtros.situacao
                                                            }
                                                            className="rounded-lg w-full flex-1 border border-gray-300 py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent mt-1"
                                                        >
                                                            <option
                                                                value="all"
                                                                className=""
                                                            >
                                                                Todas
                                                            </option>
                                                            <option
                                                                value="Pendente de confirmação da registradora"
                                                                className=""
                                                            >
                                                                Pendente
                                                            </option>
                                                            <option
                                                                value="Recusado"
                                                                className=""
                                                            >
                                                                Recusado
                                                            </option>
                                                            <option value="Confirmado">
                                                                Confirmado
                                                            </option>
                                                            <option value="Cancelado">
                                                                Cancelado
                                                            </option>
                                                            <option value="Liquidado">
                                                                Liquidado
                                                            </option>
                                                            <option value="Baixado">
                                                                Baixado
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </form>

                                            <div className="actions modal">
                                                <button
                                                    onClick={() => {
                                                        setFiltros(
                                                            defaultFiltros
                                                        )
                                                        setDateRange([
                                                            null,
                                                            null,
                                                        ])
                                                        return close()
                                                    }}
                                                    className="py-2 px-4 bg-red-600 hover:bg-red-700 focus:ring-red-500 focus:ring-offset-red-200 text-white transition ease-in duration-200 text-center text-base font-normal shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg"
                                                >
                                                    Limpar todos filtros
                                                </button>
                                            </div>
                                        </FilterContainer>
                                    </>
                                )}
                            </Popover.Panel>
                        </Popover>
                    </div>
                </div>
            </ExtractFilter>

            <Contracts>
                <Header>
                    <div className="left">
                        <div className="title">
                            <h2>Seus contratos</h2>
                        </div>
                    </div>
                    <Popover className="popover">
                        <Popover.Button>
                            <MdMoreVert size={22} />
                        </Popover.Button>
                        <Popover.Panel>
                            <div className="exports">
                                <ul>
                                    <li>
                                        <CSVLink
                                            data={dataCsv}
                                            filename="Extratos.csv"
                                            headers={headers}
                                        >
                                            <button className="button-exports">
                                                <FiDownload size={18} />
                                                Exportar CSV
                                            </button>
                                        </CSVLink>
                                    </li>
                                    <li>
                                        <button
                                            className="button-exports"
                                            onClick={exportFile}
                                        >
                                            <FiDownload size={18} /> Exportar
                                            XLSX
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </Popover.Panel>
                    </Popover>
                </Header>
                {isLoading ? (
                    <Loading />
                ) : (
                    <HistoricoTable>
                        <thead>
                            <tr>
                                <th></th>
                                <th
                                    onClick={(e) => handleOrderBy('assinatura')}
                                    className={
                                        ordenarPorDataCriacao === 'asc'
                                            ? 'order'
                                            : 'order desc'
                                    }
                                >
                                    Data <MdKeyboardArrowUp size={18} />
                                </th>
                                <th>
                                    CPF/CNPJ <br />
                                </th>
                                <th className="recedor">
                                    {filtros.categoria === 'all' && (
                                        <>
                                            Recebedor/
                                            <br />
                                            Pagador
                                        </>
                                    )}

                                    {filtros.categoria === 'pago' && (
                                        <>Recebedor</>
                                    )}

                                    {filtros.categoria === 'recebido' && (
                                        <>Pagador</>
                                    )}
                                </th>
                                <th className="adq">Adq</th>
                                <th className="categoria"></th>
                                <th
                                    onClick={(e) => handleOrderBy('valor')}
                                    className={
                                        ordenarPorValor === 'asc'
                                            ? 'order valor'
                                            : 'order desc'
                                    }
                                >
                                    Valor <MdKeyboardArrowUp size={18} />
                                </th>
                                <th className="tipo">Tipo</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>{renderContractRows()}</tbody>
                    </HistoricoTable>
                )}
            </Contracts>
            <div className="pagination">
                <Pagination
                    onChange={(e, value) => setContractsPage(value)}
                    page={contractsPage}
                    count={contractsCount}
                    color="primary"
                    variant="outlined"
                    shape="rounded"
                />
            </div>

            <Dialog
                isTermsOpen={isModalOpen}
                setIsTermsOpen={setIsModalOpen}
                title="Comprovante de Pagamento"
            >
                <ContractsModal contract={contractSelected} />
            </Dialog>
        </Container>
    )
}

export default Extratos
